export enum QueryKeyEnum {
  mediaData = "mediaData",
  getUserData = "getUserData",
}
